import * as React from 'react';
import { getStoreState, storeDispatch } from '../state/Store';
import * as Actions from '../state/actions';
import * as moment from 'moment';

export default class extends React.Component {
  updateInterval = 0;
  showLibrary = () => {
    storeDispatch(Actions.showLibrary());
  };

  updateTime = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    const { lastSave } = getStoreState().flyer;
    if (lastSave > 0 && this.updateInterval === 0) {
      this.updateInterval = window.setInterval(this.updateTime, 10000);
    }
  }

  componentWillUnmount() {
    if (this.updateInterval > 0) {
      clearInterval(this.updateInterval);
      this.updateInterval = 0;
    }
  }

  componentDidUpdate() {
    const { lastSave } = getStoreState().flyer;
    if (lastSave > 0 && this.updateInterval === 0) {
      this.updateInterval = window.setInterval(this.updateTime, 10000);
    }
    if (lastSave === 0 && this.updateInterval > 0) {
      clearInterval(this.updateInterval);
      this.updateInterval = 0;
    }
  }

  render() {
    const { id, name, lastSave } = getStoreState().flyer;
    return (
      <div className="save-ui">
        <button
          className={id === null ? 'expanded' : undefined}
          onClick={this.showLibrary}
          title="Saved projects"
        >
          Saved projects
        </button>
        {name && (
          <div className="title">
            <span>{name}</span>
            {lastSave > 0 && (
              <span className="last-save">
                Saved {moment(lastSave).fromNow()}
              </span>
            )}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/showcase/SavedTitle.tsx